import { render, staticRenderFns } from "./AgentBasicinfomation.vue?vue&type=template&id=6ccc0390&scoped=true&"
import script from "./AgentBasicinfomation.vue?vue&type=script&lang=js&"
export * from "./AgentBasicinfomation.vue?vue&type=script&lang=js&"
import style0 from "./AgentBasicinfomation.vue?vue&type=style&index=0&id=6ccc0390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccc0390",
  null
  
)

export default component.exports